var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAbout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 125",
    x: "0px",
    y: "0px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M78.85,5.5H21.15a15,15,0,0,0-15,15v71a3,3,0,0,0,5.33,1.89l12-14.79H78.85a15,15,0,0,0,15-15V20.5A15,15,0,0,0,78.85,5.5Zm9,58.1a9,9,0,0,1-9,9H23a5,5,0,0,0-3.88,1.85l-7,8.59V20.5a9,9,0,0,1,9-9h57.7a9,9,0,0,1,9,9Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50,35.17a3,3,0,0,0-3,3v20.3a3,3,0,0,0,6,0V38.17A3,3,0,0,0,50,35.17Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M50,23.17a3,3,0,0,0-3,3v2.3a3,3,0,0,0,6,0v-2.3A3,3,0,0,0,50,23.17Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbout);
export default __webpack_public_path__ + "static/media/about.68304b6c16a0cda6ddc08f90a347a73f.svg";
export { ForwardRef as ReactComponent };